import React from 'react'

import Slider from 'react-slick'
import { SliderArrow } from '../SliderArrow'

const ConditionalSlider = ({ onSlideChange, children, ...props }) => {
  const sliderProps = {
    adaptiveHeight: false,
    arrows: true,
    className: 'projects',
    cssEase: 'ease-in-out',
    currentSlide: 0,
    dots: true,
    enabled: true,
    method: {},
    nextArrow: (<SliderArrow direction="next" />),
    prevArrow: (<SliderArrow direction="prev" />),
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    variableWidth: false,
    afterChange: onSlideChange
  }
  return children && (children.length > sliderProps.slidesToShow)
    ? (<Slider { ...props } { ...sliderProps }>{ children }</Slider>)
    : (<div className={props.className || ''}>{ children }</div>)
}

export default ConditionalSlider;